import { render } from "./AtPremium.vue?vue&type=template&id=301a805c&scoped=true"
import script from "./AtPremium.vue?vue&type=script&lang=js"
export * from "./AtPremium.vue?vue&type=script&lang=js"

import "./AtPremium.vue?vue&type=style&index=0&id=301a805c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-301a805c"]])

export default __exports__